module.exports = __webpack_public_path__ + "static/media/arrowDown.e0a9cf32.svg";